export default __webpack_public_path__ + "media/images/features/local_delivery/episode7/LP_04-19f1051b7c4b8afde302272030bc382c.jpg";